import React from 'react';
import PropTypes from 'prop-types';
import './AllocationContainer.scss';
import Radio from '@material-ui/core/Radio';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { disabledButtonTextGray, textColorGray } from 'theme/mainColors';
import ManageConfigureCostObject from './ManageConfigureCostObjectConnector';
import { PERCENTAGE_OF_GROSS_RADIO_BUTTON, SELECT_ALLOCATION_UNIT_RADIO_BUTTON } from './RadioButtonsConstants';

const textStyle = { fontSize: 12, color: textColorGray };

class AllocationContainer extends React.Component {
  constructor(props) {
    super(props);
    const {
      allocationUnit:{
        id,
        name
      }
    } = props;
    const selectedValue = props.allocationUnit.id !== 0 ? SELECT_ALLOCATION_UNIT_RADIO_BUTTON : PERCENTAGE_OF_GROSS_RADIO_BUTTON;

    this.state = {
      allocationUnit:{
        id,
        name
      },
      selectedValue
    };
  }

  componentDidMount = () => this.props.allocationUnitsActions.fetchAllAllocationUnits();

  handleChange = event => {
    const radioValue = event.target.value;
    this.setState( oldState => ( {
      selectedValue: radioValue,
      allocationUnit: radioValue === PERCENTAGE_OF_GROSS_RADIO_BUTTON ? { id: 0, name: ''} : oldState.allocationUnit
    }), () => {
      this.props.onAllocationUnitChange(this.state.allocationUnit);
    });
  };

  handleSelectAllocationChange = (ev, index, value) => {
    const selectedAllocationUnit = this.props.allocationUnits.find( allocationUnit => allocationUnit.id === value );
    this.setState(oldState => ({
      allocationUnit: {
        ...oldState.allocationUnit,
        id: value,
        name: value !== 0 ? selectedAllocationUnit.name : ''
      },
      selectedValue: SELECT_ALLOCATION_UNIT_RADIO_BUTTON
    }), () => {
      this.props.onAllocationUnitChange(this.state.allocationUnit);
    });
  };

  handleCostObjectChange = newCostObjectList =>  this.props.onCostObjectChange(newCostObjectList);

  render() {
    const { allocationUnit, selectedValue } = this.state;
    const { fetchingAllocationUnits, allocationUnits, costObjects } = this.props;

    return(
      <div className="allocation-rule-container">
        <div>
          <h2>1. Select Allocation Type </h2>
          <div >
            <Radio
              checked={ selectedValue === PERCENTAGE_OF_GROSS_RADIO_BUTTON }
              onChange={ this.handleChange }
              value={ PERCENTAGE_OF_GROSS_RADIO_BUTTON }
            />
            <span>Percentage of Gross</span>
          </div>
          <div className="allocation-rule-container__allocation">
            <Radio
              checked={ selectedValue === SELECT_ALLOCATION_UNIT_RADIO_BUTTON }
              onChange={ this.handleChange }
              value={ SELECT_ALLOCATION_UNIT_RADIO_BUTTON }
            />
            <SelectField
              name={ 'allocationUnitKey' }
              hintText="Select Allocation Units"
              style={ { marginTop: 24 } }
              fullWidth={ true }
              autoWidth={ true }
              maxHeight={ 400 }
              iconStyle={ { fill: disabledButtonTextGray } }
              hintStyle={ { ...textStyle, color: disabledButtonTextGray } }
              labelStyle={ textStyle }
              underlineStyle={ { borderColor: disabledButtonTextGray } }
              value={ allocationUnit ? allocationUnit.id : 0 }
              onChange={ this.handleSelectAllocationChange }
              disabled= { fetchingAllocationUnits }
            >
              <MenuItem value={ 0 } primaryText="Select Allocation Units" style={ { color: '#bcbcbc' } } />
              {
                allocationUnits.map( allocationUnit => (
                  <MenuItem key={ allocationUnit.id } value={ allocationUnit.id } primaryText={ allocationUnit.name } />
                ))
              }
            </SelectField>
          </div>
        </div>
        <div className="allocation-rule-container__cost-object">
          <h2 style={ {marginBottom: "5px"} }>2. Configure Cost Objects</h2>
          <div>
            <ManageConfigureCostObject
              radioButtonValue={ selectedValue }
              costObjects={ costObjects }
              onCostObjectChange={ newCostObject => this.handleCostObjectChange(newCostObject) }
              allocationUnitId={ allocationUnit ? allocationUnit.id : 0 }
            />
          </div>
        </div>
      </div>
    );
  }
}


AllocationContainer.propTypes = {
  allocationUnits: PropTypes.array.isRequired,
  fetchingAllocationUnits: PropTypes.bool.isRequired,
  costObjects: PropTypes.array.isRequired,
  allocationUnit: PropTypes.object.isRequired,
  onAllocationUnitChange: PropTypes.func.isRequired,
  onCostObjectChange: PropTypes.func.isRequired,
  allocationUnitsActions: PropTypes.shape({
    fetchAllAllocationUnits: PropTypes.func.isRequired
  }).isRequired
};

AllocationContainer.defaultProps = {
  allocationUnit: {
    id:0,
    name:''
  }
};

export default AllocationContainer;



// WEBPACK FOOTER //
// ./src/components/manageRules/comp/ruleEditor/comp/ruleBuilder/allocationContainer/AllocationContainer.js